import { render, staticRenderFns } from "./base-sidebar.vue?vue&type=template&id=4a571eed&"
import script from "./base-sidebar.vue?vue&type=script&lang=ts&"
export * from "./base-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./base-sidebar.vue?vue&type=style&index=0&id=4a571eed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports